import { MatchmakingMatchTypes } from '@colonist/game-base-types';
import { uiManagerEvents } from '../EntryShared.ts';
import { UIUrlParameterNames } from '../ui_html/UIUrlController.ts';
function enterMatchmaking(matchType) {
    uiManagerEvents.handleUrlRedirectViaParameters(UIUrlParameterNames.EnterMatchmaking, matchType);
}
export function createLeaderboardsNavigationCtaConfig() {
    return {
        onClickBaseGame: ()=>enterMatchmaking(MatchmakingMatchTypes.RankedClassic4P),
        onClick1v1: ()=>enterMatchmaking(MatchmakingMatchTypes.RankedClassic1v1),
        onClickCK: ()=>enterMatchmaking(MatchmakingMatchTypes.RankedCitiesAndKnights4P),
        onClickColonistRush: ()=>enterMatchmaking(MatchmakingMatchTypes.RankedRush4P)
    };
}
